import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site, formatNumber } from '@debbie/common/dist';
import { CaseVoucherSource } from '@debbie/common/dist/economy/case-vouchers';
import { VoucherCategory, VoucherTypeIds, VoucherTypeSetting, } from '@debbie/common/dist/economy/vouchers';
import { h } from '@debbie/cortex/dist';
import { useBillingVouchers } from '@debbie/cortex/dist/billing-vouchers';
import { Money, Modal, CopyToClipboard } from '../..';
import THEME from '../../../theme';
import AlertTriangle from '../../Icons/AlertTriangle';
import CornerDownRight from '../../Icons/CornerDownRight';
import FileIcon from '../../Icons/File';
import GitMerge from '../../Icons/GitMerge';
import Info from '../../Icons/Info';
import XCircle from '../../Icons/XCircle';
import CaseVoucherInfo from './CaseVoucherInfo';
import PaymentTypeComponent from './PaymentType';
import APCOAFeeCard from '../../bespoke/APCOA/APCOAFeeCard';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import { APCOA_EI_TENANT_IDS } from '@debbie/common/dist/bespoke/apcoa';
import { Col, Row } from '../../Grid';
import q from '@debbie/cortex/dist/query';
import keys from '@debbie/common/dist/cache/keys';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers';
import { useCreditor } from '@debbie/cortex/dist/creditors';
const Voucher = (props) => {
    const { singleCase } = props;
    const site = useSelector((s) => s.site);
    const lang = useSelector((s) => s.lang);
    const creditorLoadable = useCreditor(singleCase === null || singleCase === void 0 ? void 0 : singleCase.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const onMouseIn = () => {
        if (props.caseVoucher.voucherTypeId === VoucherTypeIds.DEPOSIT) {
            props.setDepositCaseVoucherHovored(props.caseVoucher.caseVoucherId);
        }
    };
    const onMouseOut = () => {
        if (props.caseVoucher.voucherTypeId === VoucherTypeIds.DEPOSIT) {
            props.setDepositCaseVoucherHovored(null);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(VoucherStyled, { parent: props.parent != null ? props.parent : false, small: props.small != null ? props.small : false, level: props.level, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
            props.depositCaseVoucherHovored && (React.createElement(BillingTip, { caseId: props.singleCase.caseId, caseVoucherId: props.caseVoucher.caseVoucherId, depositCaseVoucherId: props.depositCaseVoucherHovored })),
            (props.caseVoucher.expired ||
                props.caseVoucher.irrecoverableDate ||
                props.caseVoucher.deletedAt) && (React.createElement(InvalidVoucherStrikethrough, { parent: props.parent != null ? props.parent : false, small: props.small != null ? props.small : false, level: props.level })),
            React.createElement(VoucherMeta, null,
                site !== Site.Debtor && (React.createElement(Info, { style: {
                        marginRight: props.small ? '0.9em' : '.5em',
                        cursor: 'pointer',
                        userSelect: 'none',
                    }, onClick: () => {
                        setInfoModalOpen(true);
                    } })),
                props.child && (React.createElement(CornerDownRight, { style: {
                        margin: '-0.1em 0.3em 0 0.3em',
                    } })),
                React.createElement("p", { style: {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    } },
                    props.caseVoucher.setting === VoucherTypeSetting.TextAsLabel &&
                        props.caseVoucher.text
                        ? props.caseVoucher.text
                        : lang.economyVoucherTypeLabels[props.caseVoucher.voucherTypeId] || props.caseVoucher.label,
                    props.caseVoucher.interest
                        ? ` ${parseFloat((props.caseVoucher.interest * 100).toFixed(3))} %`
                        : null,
                    ' ',
                    props.caseVoucher.appendix && (React.createElement(FileIcon, { style: {
                            height: '0.8em',
                            width: '0.8em',
                            margin: '0.1em 0.3em -0.1em 0.1em',
                        } })),
                    props.caseVoucher.referenceId ? (React.createElement("small", { style: {
                            maxWidth: '120px',
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }, title: props.caseVoucher.referenceId }, props.caseVoucher.referenceId)) : (''),
                    ' ',
                    props.caseVoucher.source === CaseVoucherSource.Creditor &&
                        site !== Site.Debtor && (React.createElement(GitMerge, { style: {
                            transform: 'rotate(-90deg)',
                            margin: '0.1em 0 -0.1em',
                        }, "data-for": "tooltip-economy-account", "data-tip": lang.economy.imposedByCreditor })),
                    ' ',
                    props.caseVoucher.paymentType && (React.createElement(PaymentTypeComponent, { paymentType: props.caseVoucher.paymentType })))),
            creditor && (React.createElement(CategoryInfo, null,
                React.createElement("span", { style: {
                        position: 'absolute',
                        right: props.parent || props.small ? '100px' : '100px',
                    } },
                    site === Site.Caseworker &&
                        [
                            VoucherCategory.COST,
                            VoucherCategory.COURTCOST,
                            VoucherCategory.PRINCIPAL,
                            VoucherCategory.INTEREST,
                        ].includes(props.caseVoucher.category) &&
                        !props.caseVoucher.expired &&
                        moment(props.caseVoucher.expirationDate).isBefore(moment()) && (React.createElement(AlertTriangle, { "data-for": "tooltip-economy-account", "data-tip": lang.economy.debtExpied, style: { margin: '0.2em 0.2em -0.1em' } })),
                    props.caseVoucher.expired && (React.createElement(XCircle, { "data-for": "tooltip-economy-account", "data-tip": lang.economy.debtExpied, style: {
                            margin: '0.2em 0.2em -0.1em',
                            color: 'red',
                            opacity: '0.6',
                        } })),
                    props.caseVoucher.irrecoverableDate && (React.createElement(AlertTriangle, { "data-for": "tooltip-economy-account", "data-tip": lang.economy.debtIrrecoverable, style: {
                            margin: '0.2em 0.2em -0.1em',
                            color: 'red',
                            opacity: '0.6',
                        } })),
                    moment(props.caseVoucher.date).format(THEME.DATE_FORMAT_SHORT)),
                React.createElement(Money, { color: props.caseVoucher.category === 'transaction', amount: props.caseVoucher.amount })))),
        infoModalOpen ? (React.createElement(CaseVoucherInfoModal, { caseVoucher: props.caseVoucher, setInfoModalOpen: setInfoModalOpen, caseVouchers: props.caseVouchers, singleCase: singleCase })) : null,
        props.caseVoucher.children &&
            props.caseVoucher.children
                .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                .map((childVoucher) => (React.createElement(Voucher, { level: props.level, deletable: props.deletable, small: true, category: props.category, caseVouchers: props.caseVouchers, caseVoucher: Object.assign(Object.assign({}, childVoucher), { children: [] }), parent: false, child: true, key: childVoucher.caseVoucherId, caseId: props.caseId, singleCase: singleCase, depositCaseVoucherHovored: props.depositCaseVoucherHovored, setDepositCaseVoucherHovored: props.setDepositCaseVoucherHovored })))));
};
export default Voucher;
const BillingTip = (props) => {
    const billingVouchersLoader = useBillingVouchers(props.caseId);
    const billingVouchers = h.hasData(billingVouchersLoader)
        ? billingVouchersLoader.data
        : null;
    const relatedBillingVouchers = billingVouchers &&
        billingVouchers.filter((billingVoucher) => {
            const isThisCaseBillingVoucher = billingVoucher.caseVoucherId === props.caseVoucherId;
            const isThisDepositCaseBillingVoucher = billingVoucher.depositCaseVoucherId === props.depositCaseVoucherId;
            const isVat = billingVoucher.category === VoucherCategory.VAT;
            return (isThisCaseBillingVoucher && !isVat && isThisDepositCaseBillingVoucher);
        });
    if (!(relatedBillingVouchers === null || relatedBillingVouchers === void 0 ? void 0 : relatedBillingVouchers.length)) {
        return null;
    }
    return (React.createElement(StyledBillingTip, null,
        React.createElement("p", null,
            relatedBillingVouchers.map((billingVoucher, index) => {
                let join = '';
                if (index != 0) {
                    if (billingVoucher.amount > 0) {
                        join = ' + ';
                    }
                    else {
                        join = ' - ';
                    }
                }
                const isFee = billingVoucher.category === VoucherCategory.FEE;
                return (React.createElement("span", { key: billingVoucher.billingVoucherId },
                    join,
                    React.createElement("span", { style: {
                            color: isFee ? THEME.SUCCESS : undefined,
                            fontWeight: isFee ? 900 : undefined,
                            textDecoration: billingVoucher.billingId
                                ? undefined
                                : 'underline',
                        }, key: billingVoucher.billingVoucherId },
                        formatNumber(Math.abs(billingVoucher.amount)),
                        ' ',
                        React.createElement("span", { style: { fontSize: '.8em' } },
                            "(",
                            moment(billingVoucher.date).format(THEME.DATE_FORMAT_SHORT),
                            ")"))));
            }),
            relatedBillingVouchers.length > 1 && (React.createElement(React.Fragment, null,
                ' ',
                "=",
                ' ',
                formatNumber(relatedBillingVouchers.reduce((acc, billingVoucher) => billingVoucher.amount + acc, 0)))))));
};
const CaseVoucherInfoModal = (props) => {
    const { setInfoModalOpen, caseVoucher, caseVouchers, singleCase } = props;
    const lang = useSelector((s) => s.lang);
    const tenantId = useSelector(selectTenantId);
    const parkingModuleActive = tenantId &&
        APCOA_EI_TENANT_IDS.includes(tenantId) &&
        caseVoucher.category === VoucherCategory.PRINCIPAL;
    return (React.createElement(Modal, { header: React.createElement(React.Fragment, null,
            React.createElement(CopyToClipboard, { text: props.caseVoucher.caseVoucherId, hideIcon: true },
                lang.economyVoucherTypeLabels[props.caseVoucher.voucherTypeId] || props.caseVoucher.label,
                ' ',
                props.caseVoucher.referenceId),
            ' ',
            "-",
            ' ',
            React.createElement(CopyToClipboard, { text: `${props.caseVoucher.id}` }, props.caseVoucher.id)), maxWidth: parkingModuleActive
            ? '1600px'
            : props.caseVoucher.voucherTypeId === VoucherTypeIds.DEPOSIT
                ? undefined
                : '800px', onToggle: () => setInfoModalOpen(false) }, parkingModuleActive ? (React.createElement(Row, null,
        React.createElement(Col, { width: "3" },
            React.createElement(CaseVoucherInfo, { caseVoucher: caseVoucher, caseVouchers: caseVouchers, onDeleteVoucher: () => {
                    setInfoModalOpen(false);
                    q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucher.caseVoucherId));
                }, singleCase: singleCase })),
        React.createElement(Col, { width: "9" },
            React.createElement(APCOAFeeCard, { caseVoucher: caseVoucher })))) : (React.createElement(CaseVoucherInfo, { caseVoucher: caseVoucher, caseVouchers: caseVouchers, onDeleteVoucher: () => {
            setInfoModalOpen(false);
            q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucher.caseVoucherId));
        }, singleCase: singleCase }))));
};
const VoucherStyled = styled.div `
  border-bottom: ${(props) => (props.parent ? 'none !important' : 'inherit')};
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  padding: ${(props) => props.small
    ? '0em 0 0.5em 0.1em'
    : props.parent
        ? '0.5em 0 0.25em 0em'
        : '0.25em 0 0.25em 0em'};
  font-size: ${(props) => (props.small ? '0.8em' : '1em')};

  & p {
    margin: 0;
  }

  ${(props) => (props.level === 1 ? '' : '')}
`;
const CategoryInfo = styled.div `
  display: flex;
  align-items: center;
`;
const VoucherMeta = styled.div `
  display: flex;
  align-items: center;
  max-width: calc(100% - 155px);
`;
const InvalidVoucherStrikethrough = styled.span `
  position: absolute;
  width: calc(100% - 26px);
  right: 0;
  height: 1px;
  background-color: black;
  opacity: 40%;
`;
const StyledBillingTip = styled.div `
  position: absolute;
  left: calc(100% + 10px);
  background-color: white;
  border: 1px solid lightgrey;
  border-radius: 3px;
  padding: 2px 5px;
  font-size: 0.9em;
  width: max-content;
  z-index: 9;
`;
//# sourceMappingURL=Voucher.js.map